// extracted by mini-css-extract-plugin
export var footer = "_lg-5";
export var fulfillmentInput = "_lg-0";
export var shipDateInput = "_lg-1";
export var shipmentModal = "_lg-2";
export var shipmentModalContent = "_lg-3";
export var tableContainer = "_lg-4";